"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _afterinit = _interopRequireDefault(require("./_afterinit"));

var _adddatakeys = _interopRequireDefault(require("./adddatakeys"));

var _removedatakeys = _interopRequireDefault(require("./removedatakeys"));

var _isdatakey = _interopRequireDefault(require("./isdatakey"));

var _setdata = _interopRequireDefault(require("./setdata"));

var _keyof = _interopRequireDefault(require("./keyof"));

var _keys = _interopRequireDefault(require("./keys"));

var _values = _interopRequireDefault(require("./values"));

var _entries = _interopRequireDefault(require("./entries"));

var _tojson = _interopRequireDefault(require("./tojson"));

var _each = _interopRequireDefault(require("./each"));

var _iterator = _interopRequireDefault(require("./iterator"));

var symbolIterator = typeof Symbol === 'function' ? Symbol.iterator : '@@iterator';

var _default = (0, _defineProperty2["default"])({
  _afterInit: _afterinit["default"],
  setData: _setdata["default"],
  addDataKeys: _adddatakeys["default"],
  removeDataKeys: _removedatakeys["default"],
  isDataKey: _isdatakey["default"],
  keys: _keys["default"],
  values: _values["default"],
  entries: _entries["default"],
  keyOf: _keyof["default"],
  toJSON: _tojson["default"],
  each: _each["default"],
  isSeempleObject: true,
  jset: _setdata["default"]
}, symbolIterator, _iterator["default"]);

exports["default"] = _default;
//# sourceMappingURL=_prototype.js.map